export default class BeadPatternRenderingOptions {
  constructor(
    readonly interactive: boolean,
    readonly beadOutline: boolean,
    readonly emptyPegs: boolean,
    readonly beadInnerRadiusRatio: number,
    readonly beadInnerShadow: boolean
  ) {}
}
